<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap display-inherit">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }]"
        title="応募者管理＿一覧画面の表示情報の設定"
      />
      <table class="boss-table-4">
        <tr data-test="tr-preview">
          <th
            v-for="(item, i) in defaultEntryDisplayItems"
            :key="i"
          >
            {{ item.name }}
          </th>
          <th
            v-for="(item, i) in selectedItems"
            :key="i+ '-' + item.id"
          >
            {{ item.name }}
          </th>
        </tr>
      </table>
      <div class="boss-selection-container pega-select-container clearfix">
        <div class="boss-select-container pega-select-container-left">
          <div class="boss-select-title">
            <span class="boss-select-text">設定されている表示項目</span>
          </div>
          <div class="boss-select-wrap">
            <ul
              class="boss-select-lis pega-clear-padding display-entry-setting-left-height"
              data-test="selected-item"
            >
              <div class="pega-drag-area padding-bottom-0 min-height-0">
                <li
                  v-for="(item, i) in defaultEntryDisplayItems"
                  :key="i"
                  class="boss-select-item boss-no-move pega-no-move"
                >
                  <span
                    class="boss-select-item-text"
                    v-html="item.name"
                  />
                </li>
              </div>
              <div
                v-if="isDragging"
                class="pega-drop-area border-dashed margin-bottom-1"
                data-test="drop-area"
              >
                <p>↓ この範囲に要素をドラッグしてください</p>
              </div>
              <draggable
                v-model="selectedItems"
                group="items"
                class="pega-drag-area padding-top-0 min-height-entry-columns"
                data-test="draggable-selected"
                @start="changeDragging"
                @end="changeDragging"
              >
                <li
                  v-for="(item,i) in selectedItems"
                  :key="i + '-' + item.id"
                  class="boss-select-item boss-any"
                >
                  <span
                    class="boss-select-item-text"
                    v-html="item.name"
                  />
                  <span
                    class="boss-any-text"
                  >任意</span>
                </li>
              </draggable>
              <div
                v-if="isDragging"
                class="pega-drop-area bottom"
                data-test="drop-area"
              >
                <p>↑ この範囲に要素をドラッグしてください</p>
              </div>
            </ul>
          </div>
        </div>
        <div class="boss-center-container">
          <div class="boss-arrow" />
        </div>
        <div class="boss-select-container">
          <div class="boss-select-title">
            <span class="boss-select-text">表示したい項目を右枠から左枠にドラッグしてください。</span>
          </div>
          <div class="boss-select-wrap">
            <ul
              class="boss-select-list pega-clear-padding"
              data-test="unselected-item"
            >
              <div
                v-if="isDragging"
                class="pega-drop-area top"
                data-test="drop-area"
              >
                <p>↓ この範囲に要素をドラッグしてください</p>
              </div>
              <draggable
                v-model="unselectedItems"
                class="pega-drag-area"
                group="items"
                data-test="draggable-unselected"
                @start="changeDragging"
                @end="changeDragging"
              >
                <li
                  v-for="item in unselectedItems"
                  :key="item.id"
                  class="boss-select-item boss-no-move boss-any"
                >
                  <span
                    class="boss-select-item-text"
                    v-html="item.name"
                  />
                  <span class="boss-any-text">
                    任意
                  </span>
                </li>
              </draggable>
              <div
                v-if="isDragging"
                class="pega-drop-area bottom"
                data-test="drop-area"
              >
                <p>↑ この範囲に要素をドラッグしてください</p>
              </div>
            </ul>
          </div>
        </div>
      </div>
      <div class="boss-button-container">
        <button
          class="boss-button boss-button-return"
          data-test="back"
          @click="$router.back()"
        >
          <span
            class="boss-button-return-text"
          >戻る</span>
        </button>
        <button
          class="boss-button boss-button-confirm"
          data-test="update-button"
          @click="updateDisplayItems"
        >
          <span class="boss-button-confirm-text">登録する</span>
        </button>
      </div>
    </div>
  </div>
  <!-- ▲Main Container -->
</template>
<style>
  .display-inherit {
    display: inherit !important;
  }
</style>
<script>
import draggable from 'vuedraggable'
import SettingHeader from '@/components/atoms/SettingHeader'
import _ from 'lodash'
import * as definition from '@/lib/labelValueMappings'

export default {
  components: {
    draggable,
    SettingHeader
  },
  data () {
    return {
      selectedItems: [],
      unselectedItems: [],
      defaultEntryDisplayItems: definition.defaultEntryDisplayItems,
      isDragging: false
    }
  },
  created () {
    this.fetchDisplayItems()
  },
  methods: {
    fetchDisplayItems () {
      this.$http.secured.get('/company/settings/entry/display_items').then(response => {
        this.$set(this, 'selectedItems', _.get(response.data, 'selectedItems', []))
        this.$set(this, 'unselectedItems', _.get(response.data, 'unselectedItems', []))
      })
    },
    updateDisplayItems () {
      this.$http.secured.put('/company/settings/entry/display_items', _.map(this.selectedItems, 'id')).then(response => {
        this.$toasted.global.success({ message: '表示項目を更新しました。' })
      })
    },
    changeDragging () {
      this.isDragging = !this.isDragging
    }
  }
}
</script>
